export interface AdoptiumJavaVersion {
  semver: string;
}

export interface AdoptiumJavaResponse {
  versions?: AdoptiumJavaVersion[];
}
